import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';

export class EditorJsonModel extends JsonApiModel {
  public static override readonly type = 'editors';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public email!: string;

  @Field()
  public password!: string;

  @Field()
  public role!: string;

  @Field({
    parse: (value) => { return value ? new Date(value) : null; },
    serialize: (value) => { return value ? value.getTime().toString() : null; }
  })
  public updated!: Date;

  @Field()
  public version!: number;

  @Field()
  public subjects!: string[];
}
